import React, { useState, useEffect } from "react";
import axios from "axios";
import axiosInstance from "../../../axiosInstance";
import Swal from "sweetalert2"; // Import SweetAlert2
import withReactContent from "sweetalert2-react-content"; // Import React components for SweetAlert2

import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import LoadingTable from "../../components/LoadingTable";
import { Link } from "react-router-dom";
import { useNavigate,useParams } from "react-router-dom";
import toast from "react-hot-toast";

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components

function AllUser() {
      const { id,status } = useParams();

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/admin/all-user?page=${currentPage}&limit=${limit}&search=${searchTerm}&type=${id}&status=${status ? status : ''}`
      );
      setData(response.data.users);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit,id,status]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Function to handle delete
  const handleDelete = (categoryId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      customClass: {
        popup: "custom-swal-popup", // Add a class to the entire dialog
        confirmButton: "btn-danger", // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance
          .delete(`/admin/delete-rating/${categoryId}`)
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Deleting Rating success!");
          })
          .catch((error) => {
            console.error("Error deleting data:", error);
            toast.error("Error deleting data");
          });
      }
    });
  };

  const handleStatusChange = (StatusId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-user/${StatusId}`, {
        status: newStatus,
      });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Status Updated success!");
    } catch (error) {
      console.error("Error updating rating status:", error);
      setLoading(false);
    }
  };

  const handleVerifyChange = (StatusId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-user-verify/${StatusId}`, {
        status: newStatus,
      });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Verification Updated success!");
    } catch (error) {
      console.error("Error updating rating status:", error);
      setLoading(false);
    }
  };

  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1);
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    fetchData(currentPage);
  };

  
    const [WalletLoading, setWalletLoading] = useState(true);


    let initialWalletData = {
        _id: null,
        TotalAmount: 0,
        WalletType: '',
        Amount: null,
        Comment: '',
    };

    const [WalletInputs, setWalletInputs] = useState(initialWalletData);

   const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'Amount' && parseFloat(value) < 0) {
            // You can handle the error, show a message, or prevent further action here
            // For now, let's reset the value to 0
            // You might want to handle this differently based on your UI/UX requirements
            toast.error('Negative numbers not allowed for Amount');
            return;
        } else {
            setWalletInputs((prevData) => ({ ...prevData, [name]: type === 'checkbox' ? checked : value }));

        }

    };



    const selectWallet = async (walletId) => {

        const credentials = {
            id: walletId,
        };
        setWalletLoading(true);
        try {
            const { data } = await axiosInstance.post("/auth-user", credentials);
            const { success, existingUser } = data;

            if (success) {
                setWalletInputs((prevData) => ({
                    ...prevData,
                    TotalAmount: existingUser.wallet || 0,
                    _id: existingUser._id,
                }));

                console.log("Message from backend:", existingUser);
            }
        } catch (error) {
            console.error("Error during login:", error);
            // Handle network errors, API issues, etc.
            toast.error(error.response.data.message);
        } finally {
            setWalletLoading(false);
        }

    }


    const WalletUpdate = async (walletId) => {

        setWalletLoading(true);

        if (WalletInputs.WalletType === '') {
            toast.error('Please Choose Add money OR Withdraw Money')
            return null;
        }
        if (WalletInputs.Amount === null) {
            toast.error('Please Type Amount More Then 0')
            return null;
        }
        if (WalletInputs.Comment === '') {
            toast.error('Please Type Comment')
            return null;
        }

        try {

            // await axiosInstance.post("/admin/update-wallet", WalletInputs);

            await toast.promise(axiosInstance.post("/admin/update-wallet", WalletInputs), {
                loading: "Updating funds on wallet...", // Loading message
                success: "Wallet Updated successfully!", // Success message
                error: "Failed to added funds.", // Error message
            });


        } catch (error) {
            console.error("Error On Wallet", error);
            toast.error(error.response.data.message);
        } finally {
            setWalletLoading(false);
            fetchData();
            setWalletInputs((prevData) => ({
                ...prevData,
                _id: null,
                TotalAmount: 0,
                WalletType: '',
                Amount: null,
                Comment: '',
            }));

        }

    };
    
  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4"> All {id === '1' && 'Employee' }  {id === '2' && (status === 1 ? 'Active Users':"Inactive User") }  {id === '0' && 'Admin' } </h1>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="table-responsive py-4">
            {loading ? (
              <LoadingTable />
            ) : (
              <>
                <div className="datatable-top">
                  <div className="datatable-dropdown">
                    <label>
                      <select
                        className="datatable-selector"
                        value={limit}
                        onChange={(e) => {
                          setlimit(parseInt(e.target.value, 10));
                          setCurrentPage(1); // Reset current page to 1 when the limit changes
                        }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                      </select>{" "}
                      entries per page
                    </label>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div className="datatable-search">
                      <input
                        className="datatable-input"
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </div>
                    <button className="btn btn-primary" onClick={handleSearch}>
                      {" "}
                      Search
                    </button>
                  </div>
                </div>


    <div
                                    className="modal fade"
                                    id="modal-wallet"
                                    tabIndex={-1}
                                    aria-labelledby="modal-wallet"
                                    style={{ display: "none" }}
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-centered" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h2 className="h6 modal-title">  <i className="ri-wallet-fill"></i> Wallet </h2>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                />
                                            </div>


                                            <div className="modal-body">
                                                {WalletLoading ? (
                                                    <>

                                                        <p className="skeleton mb-4" style={{ height: 50 }} > </p>
                                                        <div className='d-flex gap-2'>
                                                            <p className="skeleton mb-4 w-100" style={{ height: 50 }} > </p>
                                                            <p className="skeleton mb-4 w-100" style={{ height: 50 }} > </p>
                                                        </div>
                                                        <p className="skeleton mb-4" style={{ height: 50 }} > </p>
                                                        <p className="skeleton mb-4" style={{ height: 50 }} > </p>
                                                    </>
                                                ) : (
                                                    <>

                                                        <div className="mb-0">
                                                            <div className="form-group mt-3">
                                                                <label htmlFor="TotalAmount">Total Money</label>{" "}
                                                                <input
                                                                    className="form-control"
                                                                    id="TotalAmount"
                                                                    type="text"
                                                                    name="TotalAmount"
                                                                    value={Math.round(WalletInputs.TotalAmount)}
                                                                    disabled
                                                                />
                                                            </div>

                                                            <div className="form-group mt-3 ">
                                                                <label htmlFor="wallet">Please Choose <span className='text-danger'> (Required)</span></label>

                                                            </div>


                                                            <label
                                                                className={`btn  me-3 ${WalletInputs.WalletType === 'plus' ? WalletInputs.WalletType !== '' && 'btn-primary' : 'btn-outline-primary'}`}
                                                                type="button" htmlFor="addmoney" >
                                                                < input
                                                                    className="form-check-input d-none"
                                                                    type="radio"
                                                                    name="WalletType"
                                                                    id="addmoney" value={'plus'}
                                                                    onChange={handleChange}
                                                                />
                                                                Add Money
                                                            </label>

                                                            <label
                                                                className={`btn me-3 ${WalletInputs.WalletType === 'minus' ? WalletInputs.WalletType !== '' && 'btn-primary' : 'btn-outline-primary'}`}
                                                                type="button" htmlFor="Withdrawmoney">
                                                                <input
                                                                    className="form-check-input d-none"
                                                                    type="radio"
                                                                    name="WalletType"
                                                                    onChange={handleChange}
                                                                    id="Withdrawmoney" value={'minus'}
                                                                />
                                                                Withdraw money</label>


                                                            {/* <select
                            className="form-control select"
                            name="status"
                            style={{ width: "100%" }} onChange={handleDriverChange(OrderId)}
                          >
                            <option > Select Vendor</option>


                            {AllDriver.length > 0 ? (

                              AllDriver.map(vendor => (
                                <option value={vendor._id} key={vendor._id} selected={vendor._id === DriverId}
                                >{vendor.username}</option>
                              ))
                            ) : (
                              <p>No Vendor found.</p>
                            )}



                          </select> */}

                                                        </div>

                                                        <div className="form-group mt-3">
                                                            <label htmlFor="Amount">Add / Withdraw Money <span className='text-danger'> (Required)</span></label>
                                                            <input
                                                                className="form-control"
                                                                id="Amount"
                                                                type="number"
                                                                name="Amount"
                                                                onChange={handleChange}
                                                                value={WalletInputs.Amount}
                                                            />
                                                        </div>

                                                        <div className="form-group mt-3">
                                                            <label htmlFor="Comment">Comment <span className='text-danger'> (Required)</span></label>
                                                            <textarea
                                                                className="form-control"
                                                                id="Comment"
                                                                type="text"
                                                                name="Comment"
                                                                onChange={handleChange}
                                                                value={WalletInputs.Comment}

                                                            />
                                                        </div>

                                                    </>
                                                )}

                                            </div>
                                            <div className="modal-footer">
                                                <button
                                                    className="btn btn-secondary"
                                                    type="button"
                                                    data-bs-dismiss="modal" onClick={() => WalletUpdate(WalletInputs._id)}
                                                >
                                                    Update Wallet
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-gray-300 ms-auto"
                                                    data-bs-dismiss="modal"
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                <table className="table table-flush">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Full Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Status</th>
                      <th>Verification</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((row) => (
                      <tr key={row._id}>
                        <td>
                          {row._id}
                        </td>
                        <td>
                          {row.username} <br />
                          <span className="bg-success small text-white px-3 py-1 rounded-pill">  
                             {row.type === 1 && 'Employee' || row.type === 3 && 'Vendor' ||  row.type === 2 && 'User' || row.type === 0 && 'Admin'} </span>
                          <br/>
                          <button type="button" data-bs-target="#modal-wallet" data-bs-toggle="modal" onClick={() => selectWallet(row._id)}  className="bg-primary small text-white p-1 rounded-pill mt-2 d-inline-block px-2">  
                              <i class="ri-wallet-line"></i> {Math.round(Math.abs(row.wallet))}

                              </button>

                            </td>
                        <td> {row.email} </td>
                        <td> {row.phone} </td>
                        <td>
                          <select
                            style={{ width: "fit-content" }}
                            className={`form-control select ${row.status == 0
                              ? "text-white btn-danger"
                              : "text-white btn-success"
                              }`}
                            value={row.status}
                            name="status"
                            onChange={handleStatusChange(row._id)}
                          >
                            <option value="1">Active</option>
                            <option value="0">Inactive </option>
                          </select>

                          <br />
                        </td>
                        <td>
                          <select
                            style={{ width: "fit-content" }}
                            className={`form-control select ${row.verified === 0
                              ? "text-white btn-danger" // For row.verified === 0, apply text-white and btn-danger
                              : row.verified === 2
                                ? "text-white btn-warning" // For row.verified === 2, apply text-white and btn-warning
                                : "text-white btn-success" // For row.verified === 1 or any other value, apply text-white and btn-success
                              }`}
                            value={row.verified}
                            name="status"
                            onChange={handleVerifyChange(row._id)}
                          >
                            <option value="1">Verified</option>
                            <option value="2">Pending</option>
                            <option value="0">unverified </option>
                          </select>

                          <br />
                        </td>
                        <td>
                          <Link
                            class="btn btn-secondary"
                            to={`/user/${row._id}`}
                          >
                            View <i class="ri-user-fill"></i>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="datatable-bottom">
                  <div className="datatable-info"> </div>
                  <nav className="datatable-pagination">
                    <ul class="datatable-pagination-list">
                      <li
                        className={`datatable-pagination-list-item ${currentPage === 1
                          ? "datatable-hidden"
                          : "datatable-active"
                          }`}
                      >
                        <button
                          data-page="1"
                          class="datatable-pagination-list-item-link"
                          onClick={handlePreviousPage}
                          disabled={loading || currentPage === 1}
                          aria-label="Page 1"
                        >
                          ‹
                        </button>
                      </li>
                      <li>
                        <div className="datatable-info py-1 px-3">
                          Showing Page{" "}
                          <strong>
                            Showing Page {currentPage} of {totalPages}
                          </strong>{" "}
                        </div>
                      </li>
                      <li
                        className={`datatable-pagination-list-item ${currentPage === totalPages
                          ? "datatable-hidden"
                          : "datatable-active"
                          }`}
                      >
                        <button
                          data-page="2"
                          class="datatable-pagination-list-item-link"
                          aria-label="Page 2"
                          onClick={handleNextPage}
                          disabled={loading || currentPage === totalPages}
                        >
                          {" "}
                          {loading ? "Loading..." : "›"}{" "}
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default AllUser;